import Link from "next/link";
import { useEffect } from "react";

import { formatUrl } from "@/utils/stringUtils";

import { PostIndexProps } from "./PostIndex";

const scrollToIndex = (id: string) => {
  document.querySelector("#content")?.shadowRoot?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

function PostIndexList({ indexList }: PostIndexProps) {
  useEffect(() => {
    if (indexList) scrollToIndex(decodeURI(location.hash.slice(1)));
  }, [indexList]);

  return (
    <>
      {indexList.map((index) => {
        const indexUrl = formatUrl(index);
        return (
          <li key={index}>
            <Link
              href={`#${indexUrl}`}
              onClick={() => scrollToIndex(indexUrl)}
              scroll={false}
              className={`transition-color -z-10 text-14 text-gray/70 hover:text-gray max-post:whitespace-nowrap`}
            >
              {index}
            </Link>
          </li>
        );
      })}
    </>
  );
}

export default PostIndexList;
